import { SET_NUMERO_PROCESSO_PESQUISA_GERAL } from '../mutation-types'

const state = {
  numeroProcessoPesquisaGeral: null
}

const getters = {
  getNumeroProcessoPesquisaGeral: (state) => state.numeroProcessoPesquisaGeral
}

const mutations = {
  [SET_NUMERO_PROCESSO_PESQUISA_GERAL] (state, novoValor) {
    state.numeroProcessoPesquisaGeral = novoValor
  }
}

const actions = {
  atualizarNumeroProcessoPesquisaGeral ({ commit }, novoValor) {
    commit(SET_NUMERO_PROCESSO_PESQUISA_GERAL, novoValor)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/filtroPesquisaGeral.js